<template>
  <div class="box" :class="[theme, this.isOpen?'':'collapsed-box', isSolid?'box-solid':'']">
    <div class="box-header" :class="(isBorder || isSolid)?'with-border':''">
      <slot name="icon-title"></slot>
      <h3 class="box-title">{{ title }}</h3>
      <div class="box-tools pull-right" style="top: 5px;">
        <button v-if="btnIcon" type="button" class="btn btn-box-tool" :data-widget="widgetType" :title="tooltip" @click="btnIconClick()">
          <i :class="btnIcon"></i>
        </button>
        <select class="form-control" v-if="list" v-model="selectedItem">
          <option value="" disabled="disabled">Select Dealer</option>
          <option v-for="(item,index) in list" :value="item.value">{{ item.title }}</option>
        </select>
        <ul class="nav" v-if="imagesList" style="margin-top: 15px;">
          <li class="dropdown user user-menu">
            <a href="#" data-toggle="dropdown" class="dropdown-toggle">
              <span class="hidden-xs">Select Image</span>
              <i class="fa fa-arrow-down"></i>
            </a>
            <ul class="dropdown-menu" style="height: 450px; overflow-y: auto;">
              <li class="user-header" v-for="(img, index) in imagesList" @click="selectedImageIndex=index">
                <img :src="img.Thumbnail" class="thumbnail-image" alt="Printer Image" style="padding: 20px; border-radius: 20px;">
                <hr />
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <!-- /.box-tools -->
    </div>
    <!-- /.box-header -->
    <div class="box-body" v-show="isVisible">
      <slot name="content"></slot>
    </div>
    <!-- /.box-body -->
    <div v-if="$slots.footer && isVisible" class="box-footer">
      <slot name="footer"></slot>
    </div>
    <div v-if="this.isLoading" class="overlay">
      <i class="fa fa-refresh fa-spin"></i>
    </div>
  </div>
  <!-- /.box -->
</template>
<script>
  export default {
    name: 'va-box',
    data () {
      return {
        selectedItem: '',
        selectedImageIndex: 0,
        isVisible: true
      }
    },
    props: {
      widgetType: {
        type: String,
        default: 'collapse'
      },
      title: {
        type: String
      },
      list: {
        type: Array
      },
      imagesList: {
        type: Array
      },
      content: {
        type: String
      },
      theme: {
        type: String
      },
      isOpen: {
        type: Boolean,
        default: true
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      isSolid: {
        type: Boolean,
        default: false
      },
      isBorder: {
        type: Boolean,
        default: false
      },
      tooltip: {
        type: String
      }
    },
    computed: {
      btnIcon () {
        if (this.widgetType === 'collapse') {
          return this.isOpen ? 'fa fa-minus' : 'fa fa-plus'
        } else if (this.widgetType === 'remove') {
          return 'fa fa-times'
        } else if (this.widgetType === 'question') {
          return 'fa fa-question'
        } else if (this.widgetType === 'visible') {
          if (this.isVisible) {
            return 'fa fa-toggle-on text-green'
          } else {
            return 'fa fa-toggle-on text-red rotate180'
          }
        } else if (this.widgetType === 'window-maximize') {
          return 'fa fa-window-maximize'
        } else if (this.widgetType === 'window-restore') {
          return 'fa fa-window-restore'
        }
        return ''
      }
    },
    watch: {
      selectedItem (val) {
        this.listItemChanged(val)
      },
      selectedImageIndex (val) {
        // console.log('imageChanged >>> ' + val)
        this.$emit('imageChanged', val)
      }
    },
    created () {
      if (this.$root.isAdmin) {
        if (this.$root.dealers[0]) {
          this.selectedItem = this.$root.dealers[0].value
        }
      } else {
        if (this.$root.user && this.$root.user['.key']) {
          this.selectedItem = this.$root.user['.key']
        }
      }
    },
    methods: {
      listItemChanged (itemKey) {
        // console.log('listItemChanged >>> ' + itemKey)
        this.$emit('change', itemKey)
      },
      btnIconClick () {
        if (this.widgetType === 'collapse') {
        } else if (this.widgetType === 'window-maximize') {
          this.$emit('windowClicked')
        } else if (this.widgetType === 'window-restore') {
          this.$emit('windowClicked')
        } else if (this.widgetType === 'question') {
        } else if (this.widgetType === 'visible') {
          this.isVisible = !this.isVisible
          this.$emit('boxClicked', this.isVisible)
        }
      }
    }
  }
</script>
<style>
  .thumbnail-image{
    width: 120px;
  }
</style>



// WEBPACK FOOTER //
// VABox.vue?665c0d00